import $http from '../../shared/http';

export const genders = {
  namespaced: true,
  state: () => {
    return {
      gendersForSelect: null,
    };
  },
  getters: {
    getGendersForSelect: (state) => (currentLanguage) => {
      const genders = state?.gendersForSelect ?? [];
      if (!currentLanguage || !genders.length) {
        return [];
      }

      return (
        genders?.map?.((gender) => {
          return {
            value: gender.value,
            text: gender.localisations?.[currentLanguage]?.name || gender.text,
          };
        }) ?? []
      );
    },
  },
  mutations: {
    setGendersForSelect: (state, payload) => (state.gendersForSelect = payload),
  },
  actions: {
    async LOAD_GENDERS_FOR_SELECT({ commit }) {
      return $http('v2')
        .get('/genders')
        .then((response) => {
          commit('setGendersForSelect', response.data.data);
          return response;
        });
    },
  },
};
